module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "project-box"
  }, [_c('md-dialog-confirm', {
    ref: "deleteProjectDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.deleteProjectConfirm
    }
  }), _vm._v(" "), _c('md-card', {
    staticClass: "project-box-content"
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), (_vm.owner) ? _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Owner: " + _vm._s(_vm.owner.username))]) : _vm._e()]), _vm._v(" "), _c('md-card-content', [_c('div', {
    staticClass: "md-subtitle"
  }, [_vm._v("Last Updated")]), _vm._v(" "), _c('div', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.lastChanged))])]), _vm._v(" "), _c('md-card-actions', [_c('router-link', {
    staticClass: "md-icon-button",
    attrs: {
      "tag": "md-button",
      "to": {
        name: 'project',
        params: {
          id: _vm.project.id
        }
      },
      "click": _vm.selectProject
    }
  }, [_c('md-icon', [_vm._v("mode_edit")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Edit Project")])], 1), _vm._v(" "), (_vm.user.uid === _vm.project.ownerUID) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.deleteProject
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete Project")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-379e56c8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/dashboard/project-box.vue
// module id = 647
// module chunks = 2